import React from 'react';
import { useI18n } from '../../context/I18nContext';
import useDropdown from '../../hooks/useDropdown';
import { Icons } from '../icons/Icons';

export const LanguageToggle = () => {
  const { language, changeLanguage, t } = useI18n();
  const { isOpen, toggleDropdown, closeDropdown, dropdownRef } = useDropdown();

  const languages = [
    { code: 'it', label: t('settings.italian') },
    { code: 'en', label: t('settings.english') }
  ];

  const handleLanguageChange = (code) => {
    changeLanguage(code);
    closeDropdown();
  };

  return (
    <div ref={dropdownRef} className="relative">
      <button
        type="button"
        onClick={toggleDropdown}
        className="flex items-center gap-1.5 rounded-md px-2.5 py-2 text-sm font-semibold uppercase text-white transition-colors hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-black"
        title={t('common.language')}
        aria-label={t('common.language')}
        aria-haspopup="menu"
        aria-expanded={isOpen}
      >
        <span>{language}</span>
        <Icons.ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div
          className="absolute right-0 z-50 mt-2 w-40 overflow-hidden rounded-lg bg-white py-1 shadow-lg ring-1 ring-black/5"
          role="menu"
        >
          {languages.map(({ code, label }) => {
            const isSelected = language === code;

            return (
              <button
                key={code}
                type="button"
                onClick={() => handleLanguageChange(code)}
                className={`flex w-full items-center justify-between px-4 py-2 text-left text-sm transition-colors ${
                  isSelected
                    ? 'bg-blue-50 font-semibold text-blue-700'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
                role="menuitemradio"
                aria-checked={isSelected}
              >
                <span>{label}</span>
                <span className="text-xs font-semibold uppercase text-gray-400">{code}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

